import { useState } from "react";
import { MotionBox as Box } from "utils/motion";
import PlayIcon, { PlayRoundIcon } from "components/icons/PlayIcon";
import Button from "components/base/Button";
import Image from "components/base/Image";

export default function PlayButton({ text, scale, ...props }) {
  const btScale = scale || 1;
  const variants = {
    regular: { scale: btScale },
    hovered: { scale: btScale * 1.2 },
  };
  const [isHovered, setHovered] = useState(false);

  return (
    <Button
      onMouseEnter={() => setHovered(true)}
      onMouseLeave={() => setHovered(false)}
      {...props}
      variant="floating"
      colorScheme="white"
      px={0}
      aria-label="play"
    >
      {text}
      <Box
        variants={variants}
        initial="regular"
        animate={isHovered ? "hovered" : "regular"}
      >
        <PlayRoundIcon />
      </Box>
    </Button>
  );
}

export function PlayRoundButton({ text, scale, isHovered, ...props }) {
  const btScale = scale || 1;
  const variants = {
    regular: { scale: btScale },
    hovered: { scale: btScale * 1.2 },
  };

  return (
    <Box
      borderRadius="24px"
      variants={variants}
      initial="regular"
      animate={isHovered ? "hovered" : "regular"}
    >
      <Button
        {...props}
        variant="floating"
        colorScheme="white"
        px={0}
        aria-label="play"
        bg="#e9e9ebaa"
        borderRadius="24px"
        h="48px"
        w="48px"
      >
        {text}
        <PlayIcon />
      </Button>
    </Box>
  );
}

export function PlayBigButton({ scale, isHovered, ...props }) {
  const btScale = scale || 1;
  const variants = {
    regular: { scale: btScale },
    hovered: { scale: btScale * 1.1 },
  };

  return (
    <Box
      variants={variants}
      initial="regular"
      animate={isHovered ? "hovered" : "regular"}
    >
      <Button
        {...props}
        variant="floating"
        colorScheme="white"
        px={0}
        aria-label="play"
      >
        <Image
          src="/images/button-play.png"
          minHeight={["64px", "82px"]}
          width={["64px", "82px"]}
          objectFit="fill"
          alt="play-bt"
          style={{
            backdropFilter: "blur(5px)",
            borderRadius: "50%",
            overflow: "hidden",
          }}
        />
      </Button>
    </Box>
  );
}
